// extracted by mini-css-extract-plugin
export default {"emptyFollowUp":"empty-follow-up_emptyFollowUp__i9xBj"};